import React from "react";
import { Link, NavLink } from "react-router-dom";

const withLinkCheck = (component, link, navLink, classname) => {
	if (link[0] === "/") {
		return navLink ? (
			<NavLink to={link} className={classname}>
				{component}
			</NavLink>
		) : (
			<Link to={link} className={classname}>
				{component}
			</Link>
		);
	} else {
		return (
			<a
				href={link}
				target="_blank"
				rel="noreferrer"
				className={classname}
			>
				{component}
			</a>
		);
	}
};

export default withLinkCheck;
